import OrderRunning from '../views/order/running.vue'

/**
 * meta参数说明：
 * @property {string} [transition = ''] - 页面过度动画名
 * @property {boolean} [mapVisible = false] - 当前页面是否展示地图
 * @property {boolean} [needAuth = false] - 是否需要登录
 */
export const defaultRouteMeta = {
  transition: '',
  mapVisible: false,
  needAuth: false
}

/**
 * 获取路由meta参数
 * @param route
 * @param name
 * @return {*}
 */
export function getRouteMeta(route, name) {
  if (!route) {
    return defaultRouteMeta[name]
  }
  const { [name]: value = defaultRouteMeta[name] } = route.meta || {}
  return value
}

export default [
  {
    path: '/',
    name: 'Home',
    meta: {
      transition: 'fade',
      mapVisible: true
    },
    component: () =>
      import(/* webpackChunkName: "home-v2" */ '@/views/home-v2/index.vue')
  },
  {
    path: '/user',
    name: 'User',
    component: () =>
      import(/* webpackChunkName: "user" */ '../views/user/index.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () =>
      import(/* webpackChunkName: "login" */ '../views/user/login.vue')
  },
  {
    path: '/orders',
    name: 'Orders',
    meta: {
      needAuth: true
    },
    component: () =>
      import(/* webpackChunkName: "orders" */ '../views/order/orders.vue')
  },
  {
    path: '/order',
    name: 'Order',
    component: () =>
      import(/* webpackChunkName: "order" */ '../views/order/order.vue')
  },
  {
    path: '/order-cancel',
    name: 'OrderCancel',
    meta: {
      mapVisible: true,
      needAuth: true
    },
    component: () =>
      import(/* webpackChunkName: "order-cancel" */ '../views/order/cancel.vue')
  },
  {
    path: '/order-running',
    name: 'OrderRunning',
    meta: {
      mapVisible: true,
      needAuth: true
    },
    component: OrderRunning
    // component: () => import(/* webpackChunkName: "order-running" */ '../views/order/running.vue')
  },
  {
    path: '/poi',
    name: 'Poi',
    meta: {
      transition: '',
      mapVisible: false
    },
    component: () =>
      import(/* webpackChunkName: "poi" */ '../views/poi/index.vue')
  },
  // {
  // 	path: '/use-guide',
  // 	name: 'UseGuide',
  // 	component: () => import(/* webpackChunkName: "use-guide" */ '../views/guide/use.vue')
  // },
  {
    path: '/feedback',
    name: 'Feedback',
    meta: {
      needAuth: true
    },
    component: () =>
      import(/* webpackChunkName: "feedback" */ '../views/user/feedback.vue')
  },
  {
    path: '/coupons',
    name: 'CouponsView',
    meta: {
      needAuth: true
    },
    component: () =>
      import(/* webpackChunkName: "coupons" */ '../views/coupon/coupons.vue')
  },
  {
    path: '/coupon-choose',
    name: 'choose',
    meta: {
      needAuth: true
    },
    component: () =>
      import(/* webpackChunkName: "choose" */ '../views/coupon/choose.vue')
  },
  {
    path: '/share-bridge',
    name: 'shareBridge',
    component: () =>
      import(
        /* webpackChunkName: "shareBridge" */ '../views/share/share-bridge.vue'
      )
  },
  {
    path: '/activity-list',
    name: 'activityList',
    meta: {
      needAuth: true,
      mapVisible: false
    },
    component: () =>
      import(
        /* webpackChunkName: "activityList" */ '../views/activity/activity-list.vue'
      )
  },
  {
    path: '/activity-invite',
    name: 'activityInvite',
    meta: {
      needAuth: true,
      mapVisible: false
    },
    component: () =>
      import(
        /* webpackChunkName: "activityInvite" */ '../views/activity/activity-invite.vue'
      )
  },
  {
    path: '/makeup-ticket',
    name: 'makeupTicket',
    meta: {
      needAuth: true,
      mapVisible: false
    },
    component: () =>
      import(
        /* webpackChunkName: "makeupTicket" */ '../views/makeup-ticket/index.vue'
      )
  },
  {
    path: '/direct-call',
    name: 'directCall',
    meta: {
      needAuth: true,
      mapVisible: false
    },
    component: () =>
      import(
        /* webpackChunkName: "directCall" */ '../views/direct-call/index.vue'
      )
  },
  {
    path: '/direct-call-list',
    name: 'directCallList',
    meta: {
      needAuth: true,
      mapVisible: false
    },
    component: () =>
      import(
        /* webpackChunkName: "directCallList" */ '../views/direct-call/DirectCallList.vue'
      )
  },
  {
    path: '/alipay',
    name: 'alipayView',
    meta: {
      needAuth: false,
      mapVisible: false
    },
    component: () =>
      import(
        /* webpackChunkName: "alipayView" */ '../views/order/alipay.vue'
      )
  }
]
